export default __webpack_public_path__ + "8104fd59b4cb714c25fb3b16b6466e75.png";